import { render, staticRenderFns } from "./IncomeDynamicTable.vue?vue&type=template&id=823b304e&"
import script from "./IncomeDynamicTable.vue?vue&type=script&lang=js&"
export * from "./IncomeDynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./IncomeDynamicTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports